import { deepMap } from 'nanostores';

export const $directoriesStore = deepMap({
  directories: {},
});
